import { render } from "./TransportCreate.vue?vue&type=template&id=5c733167"
import script from "./TransportCreate.vue?vue&type=script&lang=js"
export * from "./TransportCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__